<template>
  <!-- AppInput do app: campo arredondado -->
  <div class="search-bar d-flex align-items-center">
    <input
      spellcheck="false"
      class="search-bar-input text-paragraph text-primary flex-grow-1"
      v-model.trim="searchString"
      type="text"
      :placeholder="placeholder"
      id="search-bar-input"
      v-on:keyup.enter="onSearch"
    />
    <button class="btn btn-link text-primary50 p-0 search-bar-btn" aria-label="Buscar" @click="onSearch">
      <i class="fa fa-search"></i>
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

withDefaults(defineProps<{ placeholder?: string }>(), { placeholder: "Pesquisar" });
const emit = defineEmits<{ onSearch: [value: string] }>();
const searchString = ref("");
const onSearch = () => emit("onSearch", searchString.value);
const setValue = (value: string) => {
  searchString.value = value;
};
defineExpose({ setValue });
</script>

<style scoped lang="scss">
@import "@/assets/theme/scss/user-variables";

.search-bar {
  border: 1px solid $primary10;
  border-radius: 25px;
  background: $white;
  height: 50px;
  padding: 0 20px;
}

.search-bar-input {
  border: 0;
  outline: none;
  background: transparent;
}

.search-bar-input::placeholder {
  color: $primary25;
}
</style>
